import { GrcNotify, NotifyType } from '@grc/ui-package';
import {
  buildBusinessEntitiesUrl,
  fetchBusinessEntities,
  routeBusinessEntityQuery
} from '@grc/ui-shared';
import { tenantService } from '../../common/constants/constants';

const inflightBusinessEntities = new Map<string, Promise<any>>();

const requestKey = (data: any): string => {
  const target = routeBusinessEntityQuery(data);
  if (target.route === 'byids') return `byids:${target.ids.join(',')}`;
  if (target.route === 'search') return target.url;
  // Blank ids resolve to an empty result without a request, never a list-all.
  if (target.route === 'none') return 'none';
  return buildBusinessEntitiesUrl(data);
};

export const getBusinessEntities = async (fetchData: any, data: any) => {
  try {
    const key = requestKey(data);

    const existing = inflightBusinessEntities.get(key);
    if (existing) return existing;

    const request = fetchBusinessEntities(
      fetchData,
      data,
      buildBusinessEntitiesUrl(data),
      (message: any) => GrcNotify({ message, status: NotifyType.Error }),
      tenantService
    )
      .then((response: any) =>
        response?.data?.length > 0 ? response.data : []
      )
      .catch((error: any) => {
        GrcNotify({ message: error.message, status: NotifyType.Error });
        return undefined;
      })
      .finally(() => {
        inflightBusinessEntities.delete(key);
      });

    inflightBusinessEntities.set(key, request);
    return request;
  } catch (error: any) {
    GrcNotify({
      message: error.message,
      status: NotifyType.Error
    });
    return undefined;
  }
};
